<app-layout
  [title]="currentFormService.definition()?.name || ''"
  [client]="currentFormService.client()?.name || ''"
>
<div class="pt-30">
  <div class="flex flex-col gap-5">
    <div class="flex justify-center items-center text-center">
      <div class="text-center flex flex-col items-center justify-center">
        <svg
          class="text-green-300 text-[120px]"
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            fill="currentColor"
            d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"
          />
        </svg>
        <p class="text-2xl text-center">Formulaire terminé</p>
      </div>
    </div>

      @if (nextForms().length > 0) {
        <div class="flex flex-col bg-white rounded-xl p-5 text-center mx-4">
          <p class="mb-5">Il y a d'autre formulaire a faire lié a ce salarié</p>
          <ul class="flex flex-col gap-2">
            @for (form of nextForms(); track form._id) {
              <li>
                <a
                  [routerLink]="['/forms', form._id, 1]"
                  [queryParams]="{
                    notification_id: currentFormService.notification()?._id || undefined,
                  }"
                  class="btn btn-primary"
                  >{{ form.name }}</a
                >
              </li>
            }
            <li>
                <a
                  [routerLink]="['/']"
                  class="btn btn-error"
                  onclick="removeSavedForms()"
                  >Le salarié ne s'est pas présenté.</a
                >
              </li>
          </ul>
        </div>
      } @else {
        <div class="flex justify-center">
          <a [routerLink]="['']" class="btn btn-primary">Retourner a l'accueil</a>
        </div>
      }
  </div>
</div>
</app-layout>
